var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2468 22.0003C10.8918 22.0003 9.57084 21.9853 8.26384 21.9583C6.59184 21.9253 5.43484 20.8413 5.24584 19.1293C4.93084 16.2893 4.39184 9.59527 4.38684 9.52827C4.35284 9.11527 4.66084 8.75327 5.07384 8.72027C5.48084 8.70927 5.84884 8.99527 5.88184 9.40727C5.88684 9.47527 6.42484 16.1463 6.73684 18.9643C6.84384 19.9373 7.36884 20.4393 8.29484 20.4583C10.7948 20.5113 13.3458 20.5143 16.0958 20.4643C17.0798 20.4453 17.6118 19.9533 17.7218 18.9573C18.0318 16.1633 18.5718 9.47527 18.5778 9.40727C18.6108 8.99527 18.9758 8.70727 19.3848 8.72027C19.7978 8.75427 20.1058 9.11527 20.0728 9.52827C20.0668 9.59627 19.5248 16.3073 19.2128 19.1223C19.0188 20.8693 17.8648 21.9323 16.1228 21.9643C14.7898 21.9873 13.5038 22.0003 12.2468 22.0003Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.708 6.98956H3.75C3.336 6.98956 3 6.65356 3 6.23956C3 5.82556 3.336 5.48956 3.75 5.48956H20.708C21.122 5.48956 21.458 5.82556 21.458 6.23956C21.458 6.65356 21.122 6.98956 20.708 6.98956Z",
    fill: "#F5222D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4406 6.98955C16.3026 6.98955 15.3146 6.17855 15.0906 5.06255L14.8476 3.84655C14.7966 3.66155 14.5856 3.50055 14.3456 3.50055H10.1126C9.87258 3.50055 9.66158 3.66155 9.60058 3.89255L9.36758 5.06255C9.14458 6.17855 8.15558 6.98955 7.01758 6.98955C6.60358 6.98955 6.26758 6.65355 6.26758 6.23955C6.26758 5.82555 6.60358 5.48955 7.01758 5.48955C7.44358 5.48955 7.81358 5.18555 7.89758 4.76755L8.14058 3.55155C8.38758 2.61955 9.19458 2.00055 10.1126 2.00055H14.3456C15.2636 2.00055 16.0706 2.61955 16.3076 3.50655L16.5616 4.76755C16.6446 5.18555 17.0146 5.48955 17.4406 5.48955C17.8546 5.48955 18.1906 5.82555 18.1906 6.23955C18.1906 6.65355 17.8546 6.98955 17.4406 6.98955Z",
    fill: "#F5222D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDelete);
export default __webpack_public_path__ + "static/media/icon-file-delete.e3fed08e1c2e16109b89e7896699f60b.svg";
export { ForwardRef as ReactComponent };